import React from "react";
import { Check } from "lucide-react";

const TRUST = ["No automatic publishing without approval", "Clear preview and availability labels", "Protected server-side early-access submissions", "No sale of early-access request information"];

export default function Trust() {
  return (
    <section id="trust" className="z-section-compact" data-testid="trust">
      <div className="z-page">
        <div className="z-frame p-6 md:p-10 lg:p-12">
          <p className="z-eyebrow">Built for professional control</p>
          <h2 className="mt-3 font-display text-[28px] md:text-[38px] leading-[1.1] max-w-[25ch]">Human authority remains part of the workflow.</h2>
          <p className="mt-4 max-w-[72ch] text-[16px] md:text-[17px] leading-[1.65] text-[hsl(var(--z-text-muted))]">Culmora is being designed so meaningful actions remain reviewable, permissions stay explicit and work moves forward only after user approval.</p>
          <ul className="mt-8 grid gap-3 md:grid-cols-2">{TRUST.map((item) => <li key={item} className="z-card-compact flex items-center gap-3 p-4 text-[15px] md:text-[16px]"><Check size={18} className="shrink-0 text-[hsl(var(--z-teal))]" aria-hidden="true"/><span>{item}</span></li>)}</ul>
          <p className="mt-8 font-display text-[19px] md:text-[21px]">Designed for professional work. Built for a global audience.</p>
        </div>
      </div>
    </section>
  );
}
